import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PaymentFacadeService} from '@core/services/entities/payment/payment-facade.service';
import {CompanyRequisitesDto} from '@core/models/payment.model';
import {CompanyService} from '@core/services/entities/company/company.service';
import {filter, take} from 'rxjs/operators';

/**
 * Минимальная форма реквизитов компании: название и ИНН.
 * Этого достаточно для строки «Плательщик» в счёте на оплату —
 * банк/счёт/адрес плательщика на счёте необязательны.
 */
@Component({
  selector: 'company-requisites-form',
  templateUrl: './company-requisites-form.component.html',
  styleUrls: ['./company-requisites-form.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyRequisitesFormComponent implements OnInit {
  @Input() hideChrome = false;
  @Output() saved = new EventEmitter<void>();

  form: FormGroup;
  companyId: string | null = null;

  constructor(
    private fb: FormBuilder,
    private facade: PaymentFacadeService,
    private companyService: CompanyService,
  ) {
    this.form = this.fb.group({
      rCompanyName: ['', Validators.required],
      rInn: ['', [Validators.required, Validators.pattern(/^\d{10}(\d{2})?$/)]],
    });
  }

  ngOnInit(): void {
    this.companyService.getCompanyId().pipe(
      filter((id: string | null) => !!id),
      take(1),
    ).subscribe((id: string) => {
      this.companyId = id;
      this.facade.requisites(id).subscribe(dto => this.form.patchValue(dto));
    });
  }

  submit(): void {
    if (this.form.invalid || !this.companyId) {
      this.form.markAllAsTouched();
      return;
    }

    this.facade
      .updateRequisites(this.companyId, this.form.value as Partial<CompanyRequisitesDto>)
      .subscribe(() => this.saved.emit());
  }
}
